<!-- Mobile block screen -->
<div class="md:hidden fixed inset-0 z-[9999] bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700 flex flex-col items-center justify-center p-8 text-center">
  <img src="icons/direct-logo-footer.png" alt="Direct Savings & Loans" class="h-12 w-auto mb-8"/>
  <div class="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6 border border-white/20">
    <svg class="w-8 h-8 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
    </svg>
  </div>
  <h2 class="text-xl font-bold text-white mb-2">Desktop Required</h2>
  <p class="text-sm text-white/60 leading-relaxed max-w-xs">The Back Office portal is designed for desktop use. Please open it on a laptop or computer for the best experience.</p>
  <div class="mt-8 px-4 py-3 bg-white/10 border border-white/20 rounded-xl">
    <p class="text-[11px] font-bold text-white/40 uppercase tracking-widest">Back Office</p>
    <p class="text-xs text-white/50 mt-0.5">Direct Savings & Loans</p>
  </div>
</div>

<main class="min-h-screen bg-slate-100 dark:bg-slate-900">
  <div class="flex">
    <!-- Sidebar -->
    <aside class="w-60 h-screen sticky top-0 flex-shrink-0 shadow-lg">
      <app-side-navbar></app-side-navbar>
    </aside>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col min-h-screen min-w-0">
      <!-- Menu Bar -->
      <header class="sticky top-0 z-50">
        <app-menu-bar></app-menu-bar>
      </header>

      <!-- Router Outlet -->
      <section class="flex-1 p-6 lg:p-7">
        <router-outlet></router-outlet>
      </section>
    </div>
  </div>
</main>
